// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';


import './assets/css/style.css';
import './assets/css/navbar.css';
import './assets/css/history.css';
import './assets/css/offers.css';
import './assets/css/offer-tabs.css';
import './assets/css/blog.css';
import './assets/css/otp.css';

Vue.config.productionTip = false
axios.defaults.baseURL = 'https://convert.airtimetocash.co.ke';
// axios.defaults.baseURL ='http://127.0.0.1:8000'
Vue.prototype.$axios = axios;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js